import { Suspense, useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router";

import { AppSidebar } from "@/components/app-sidebar";
import { SiteHeader } from "@/components/site-header";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { Skeleton } from "@/components/ui/skeleton";
import { ResourcesProvider } from "@/providers/resources.provider";

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const authToken = localStorage.getItem("auth-token");

  useEffect(() => {
    if (!authToken) {
      navigate("/log-in", { replace: true });
    }
  }, [pathname, authToken, navigate]);

  if (!authToken) {
    return <Navigate to={"/log-in"} />;
  }

  return (
    <SidebarProvider
      style={
        {
          "--sidebar-width": "calc(var(--spacing) * 72)",
          "--header-height": "calc(var(--spacing) * 12)",
        } as React.CSSProperties
      }
    >
      <AppSidebar variant="inset" />
      <SidebarInset>
        <SiteHeader />
        <div className="flex flex-1 flex-col">
          <div className="@container/main flex flex-1 flex-col gap-2 p-8 pt-0">
            <Suspense fallback={<Skeleton className="h-full w-full" />}>
              <ResourcesProvider>
                <Outlet />
              </ResourcesProvider>
            </Suspense>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
